import {
  SET_EQUIPMENT,
  SET_ERROR_MESSAGE_EQUIPMENT_BREAKDOWN,
  SET_ERROR_PROMPT_EQUIPMENT_BREAKDOWN,
  SET_SUCCESS_MESSAGE_EQUIPMENT_BREAKDOWN,
  SET_SUCCESS_PROMPT_EQUIPMENT_BREAKDOWN,
  SET_LOADING_ANNOUNCEMENT_EQUIPMENT_BREAKDOWN,
  SET_BREAKDOWN_ANNOUNCEMENT,
  SET_EDIT_BREAKDOWN_ANNOUNCEMENT,
  SET_EQUIPMENT_CONFIG,
  SET_ERROR_PROMPT_REMARK_DIALOG,
  SET_ERROR_MESSAGE_REMARK_DIALOG,
} from "../../actionTypes/bplrt/equipmentActionType";

import { bplrtAXIOS, initiateAXIOS } from "../../../../config/axios";
import {
  instanceEquipmentBreakdownAPI as equipmentAPI,
  initiateScheduleAPI,
  instanceBPLRTDisruptionAPI,
  instanceSMPAPI,
} from "../../../../api";
import { handleError } from "../../../../store/handleError";
import { logger } from "../../../../helpers/logger";
import { handleTimeoutPrompt } from "../../../../store/handlePrompt";
import { SET_UPDATE_STATION } from "../../actionTypes/bplrt/smpActionType";

import i18n from "i18next";
import { isEmpty } from "lodash";
const t = i18n.getFixedT(null, "bplrtEquipment");

export const getEquipment = () => {
  return async (dispatch) => {
    const access_token = sessionStorage.getItem("access_token");
    dispatch({
      type: SET_LOADING_ANNOUNCEMENT_EQUIPMENT_BREAKDOWN,
      payload: true,
    });

    try {
      const { data } = await bplrtAXIOS.get(equipmentAPI + "?limit=100", {
        headers: { authorization: `Bearer ${access_token}` },
      });

      const stationData = await bplrtAXIOS.get(
        instanceSMPAPI + "station?limit=100",
        {
          headers: { authorization: `Bearer ${access_token}` },
        }
      );
      const stationItem = stationData.data.items;

      const combinedData = data.items.map((item) => {
        const findStation = stationItem.find(
          (station) => station.id === item.stationId
        );

        return {
          ...item,
          station: {
            code: findStation ? findStation.code : null,
            name: findStation ? findStation.name : null,
          },
        };
      });

      dispatch({ type: SET_EQUIPMENT, payload: combinedData });
    } catch (error) {
      logger.log(error);
      const errorMessage = handleError(error);
      dispatch({
        type: SET_ERROR_PROMPT_EQUIPMENT_BREAKDOWN,
        payload: true,
      });
      dispatch({
        type: SET_ERROR_MESSAGE_EQUIPMENT_BREAKDOWN,
        payload: errorMessage,
      });
      handleTimeoutPrompt(dispatch, SET_ERROR_PROMPT_EQUIPMENT_BREAKDOWN);
    } finally {
      dispatch({
        type: SET_LOADING_ANNOUNCEMENT_EQUIPMENT_BREAKDOWN,
        payload: false,
      });
    }
  };
};

export const getEquipmentConfig = () => {
  return async (dispatch) => {
    const access_token = sessionStorage.getItem("access_token");
    dispatch({
      type: SET_LOADING_ANNOUNCEMENT_EQUIPMENT_BREAKDOWN,
      payload: true,
    });

    try {
      const { data } = await bplrtAXIOS.get(
        instanceBPLRTDisruptionAPI + "equipment",
        {
          headers: { authorization: `Bearer ${access_token}` },
        }
      );

      let storePayload = { isPeakHour: data.isPeakHour, announcement: [] };
      let responses = [];
      if (!isEmpty(data.equipmentDisruptionSchedules)) {
        try {
          responses = await Promise.all(
            data.equipmentDisruptionSchedules.map(async (schedule) => {
              const { data } = await initiateAXIOS.get(
                initiateScheduleAPI + schedule.id,
                {
                  headers: { authorization: `Bearer ${access_token}` },
                }
              );

              return data;
            })
          );

          console.log("All responses:", responses);
        } catch (err) {
          console.error("Some API call failed:", err);
        }

        storePayload.announcement = responses;
      }

      dispatch({ type: SET_EQUIPMENT_CONFIG, payload: storePayload });
    } catch (error) {
      const errorMessage = handleError(error);
      console.log(errorMessage);
      dispatch({
        type: SET_ERROR_PROMPT_EQUIPMENT_BREAKDOWN,
        payload: true,
      });
      dispatch({
        type: SET_ERROR_MESSAGE_EQUIPMENT_BREAKDOWN,
        payload: errorMessage,
      });
      handleTimeoutPrompt(dispatch, SET_ERROR_PROMPT_EQUIPMENT_BREAKDOWN);
    } finally {
      dispatch({
        type: SET_LOADING_ANNOUNCEMENT_EQUIPMENT_BREAKDOWN,
        payload: false,
      });
    }
  };
};

export const editEquipment = (payload) => {
  return async (dispatch) => {
    const access_token = sessionStorage.getItem("access_token");
    dispatch({
      type: SET_LOADING_ANNOUNCEMENT_EQUIPMENT_BREAKDOWN,
      payload: true,
    });

    try {
      await bplrtAXIOS.patch(equipmentAPI, payload, {
        headers: { authorization: `Bearer ${access_token}` },
      });

      dispatch({
        type: SET_SUCCESS_PROMPT_EQUIPMENT_BREAKDOWN,
        payload: true,
      });
      dispatch({
        type: SET_SUCCESS_MESSAGE_EQUIPMENT_BREAKDOWN,
        payload:
          payload.equipments[0].isDisrupted === false
            ? t("message.removeBreakdownSuccess")
            : t("message.addBreakdownSuccess"),
      });

      handleTimeoutPrompt(dispatch, SET_SUCCESS_PROMPT_EQUIPMENT_BREAKDOWN);
    } catch (error) {
      logger.log(error);
      const errorMessage = handleError(error);
      dispatch({
        type: SET_ERROR_PROMPT_EQUIPMENT_BREAKDOWN,
        payload: true,
      });
      dispatch({
        type: SET_ERROR_MESSAGE_EQUIPMENT_BREAKDOWN,
        payload: errorMessage,
      });
      handleTimeoutPrompt(dispatch, SET_ERROR_PROMPT_EQUIPMENT_BREAKDOWN);
    } finally {
      dispatch(getEquipment());
    }
  };
};

export const editRemark = (payload, callback) => {
  return async (dispatch) => {
    const access_token = sessionStorage.getItem("access_token");
    try {
      await Promise.all(
        payload.map(async (item) => {
          const { data } = await bplrtAXIOS.patch(
            instanceSMPAPI + "station/" + item.id,
            { comment: item.comment },
            {
              headers: { authorization: `Bearer ${access_token}` },
            }
          );

          dispatch({ type: SET_UPDATE_STATION, payload: data });
          return;
        })
      );

      dispatch({
        type: SET_SUCCESS_PROMPT_EQUIPMENT_BREAKDOWN,
        payload: true,
      });
      dispatch({
        type: SET_SUCCESS_MESSAGE_EQUIPMENT_BREAKDOWN,
        payload: t("message.remarkUpdateSuccess"),
      });
      handleTimeoutPrompt(dispatch, SET_SUCCESS_PROMPT_EQUIPMENT_BREAKDOWN);
      callback(true);
    } catch (error) {
      logger.error(error);
      const errorMessage = handleError(error);
      dispatch({
        type: SET_ERROR_PROMPT_REMARK_DIALOG,
        payload: true,
      });
      dispatch({
        type: SET_ERROR_MESSAGE_REMARK_DIALOG,
        payload: errorMessage,
      });
      handleTimeoutPrompt(dispatch, SET_ERROR_PROMPT_REMARK_DIALOG);
      callback(false);
    }
  };
};

export const linkAnnouncement = (payload) => {
  return async (dispatch) => {
    const access_token = sessionStorage.getItem("access_token");
    dispatch({
      type: SET_LOADING_ANNOUNCEMENT_EQUIPMENT_BREAKDOWN,
      payload: true,
    });

    try {
      const idOnly = payload.schedules.map((schedule) => ({
        id: Number(schedule.id),
      }));
      await bplrtAXIOS.patch(
        instanceBPLRTDisruptionAPI + "equipment",
        { equipmentDisruptionSchedules: idOnly },
        {
          headers: { authorization: `Bearer ${access_token}` },
        }
      );

      dispatch({
        type: SET_BREAKDOWN_ANNOUNCEMENT,
        payload: payload.schedules,
      });

      dispatch({
        type: SET_SUCCESS_PROMPT_EQUIPMENT_BREAKDOWN,
        payload: true,
      });
      dispatch({
        type: SET_SUCCESS_MESSAGE_EQUIPMENT_BREAKDOWN,
        payload: t("message.announcementLinkSuccessGeneral"),
      });

      handleTimeoutPrompt(dispatch, SET_SUCCESS_PROMPT_EQUIPMENT_BREAKDOWN);
    } catch (error) {
      const errorMessage = handleError(error);
      console.log(errorMessage);
      dispatch({
        type: SET_ERROR_PROMPT_EQUIPMENT_BREAKDOWN,
        payload: true,
      });
      dispatch({
        type: SET_ERROR_MESSAGE_EQUIPMENT_BREAKDOWN,
        payload: errorMessage,
      });
      handleTimeoutPrompt(dispatch, SET_ERROR_PROMPT_EQUIPMENT_BREAKDOWN);
    } finally {
      dispatch({
        type: SET_LOADING_ANNOUNCEMENT_EQUIPMENT_BREAKDOWN,
        payload: false,
      });
    }
  };
};

export const updateBreakdownAnnouncementStatus = (payload) => {
  return async (dispatch) => {
    dispatch({
      type: SET_LOADING_ANNOUNCEMENT_EQUIPMENT_BREAKDOWN,
      payload: true,
    });
    const access_token = sessionStorage.getItem("access_token");

    try {
      if (payload.active) {
        // 🟢 Activate all announcements
        await Promise.all(
          payload.announcements.map(
            async (a) =>
              await initiateAXIOS.post(
                initiateScheduleAPI + a.id + "/activate",
                {},
                {
                  headers: { authorization: `Bearer ${access_token}` },
                }
              )
          )
        );
      } else {
        // 🔴 Deactivate only the active ones
        await Promise.all(
          payload.announcements
            .filter((a) => a.isActive) // only active announcements
            .map(
              async (a) =>
                await initiateAXIOS.post(
                  initiateScheduleAPI + a.id + "/deactivate",
                  {},
                  {
                    headers: { authorization: `Bearer ${access_token}` },
                  }
                )
            )
        );
      }

      const updatedAnnouncements = payload.announcements.map((a) => ({
        ...a,
        isActive: payload.active,
      }));

      dispatch({
        type: SET_EDIT_BREAKDOWN_ANNOUNCEMENT,
        payload: updatedAnnouncements,
      });

      dispatch({
        type: SET_SUCCESS_PROMPT_EQUIPMENT_BREAKDOWN,
        payload: true,
      });
      dispatch({
        type: SET_SUCCESS_MESSAGE_EQUIPMENT_BREAKDOWN,
        payload: payload.active
          ? t("message.announcementActivated")
          : t("message.announcementDeactivated"),
      });

      handleTimeoutPrompt(dispatch, SET_SUCCESS_PROMPT_EQUIPMENT_BREAKDOWN);
    } catch (error) {
      const errorMessage = handleError(error);
      dispatch({ type: SET_ERROR_PROMPT_EQUIPMENT_BREAKDOWN, payload: true });
      dispatch({
        type: SET_ERROR_MESSAGE_EQUIPMENT_BREAKDOWN,
        payload: errorMessage,
      });
      handleTimeoutPrompt(dispatch, SET_ERROR_PROMPT_EQUIPMENT_BREAKDOWN);
    } finally {
      dispatch({
        type: SET_LOADING_ANNOUNCEMENT_EQUIPMENT_BREAKDOWN,
        payload: false,
      });
    }
  };
};
